import { PropsWithChildren, useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import useParameters from "@src/app/parameters/useParameter";
import i18n, { configureI18n } from "../core/i18n";

export default function I18NextProvider({ children }: PropsWithChildren) {
  // preload parameters
  const parameters = useParameters();
  const [i18nConfig, setI18nConfig] = useState<typeof i18n>();
  useEffect(() => {
    if (i18nConfig) return;
    if (!parameters) return;

    // configure i18n with languages from parameters;
    const config = configureI18n(parameters["languages"] as string[]);
    setI18nConfig(config);
  }, [parameters, i18nConfig]);

  if (!parameters || !i18nConfig) return <></>;

  return <I18nextProvider i18n={i18nConfig}>{children}</I18nextProvider>;
}
